import React, { Component } from "react";
import PageTitle from "../common/text/PageTitle";
import translate from "react-i18next/dist/commonjs/translate";

class GeneralErrorPage extends Component {
  constructor(props) {
    super(props);

    this.tryAgain = this.tryAgain.bind(this);
  }

  tryAgain() {
    window.location = `${global.applicationPath}/`;
  }

  render() {
    const { t } = this.props;
    return (
      <div className="dashboard-page">
        <PageTitle text={t("GeneralErrorPageHeader")} />
        <div className="main-content">
          <div className="errorPageContainer">
            <p className="errorPageText">{t("GeneralErrorPageHeader")}</p>
            <div className="button buttonPrimary" onClick={this.tryAgain}>
              <i className="buttonIcon fa fa-1 fa-refresh" />
              {t("tryAgain")}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate("translations")(GeneralErrorPage);



// WEBPACK FOOTER //
// ./src/error/GeneralErrorPage.js